<div class="become-payer">
  <div class="become-payer-header">
    <h3 class="title">
      Стати платником
    </h3>
    <button mat-button
            mat-icon-button
            aria-label="close modal"
            matDialogClose>
      <mat-icon class="material-icons_grey">close</mat-icon>
    </button>
  </div>
  <mat-progress-bar [style.opacity]="+(loading$ | async)" mode="indeterminate"></mat-progress-bar>

  <div class="become-payer-container">
    <div class="content-wrapper">
      <p class="content-wrapper-sub-title">
        Стати платником можливо після підтвердження номера телефону відправника або отримувача та ЄДРПОУ вашої організації, як платника по обраній накладній.
      </p>
      <p class="content-wrapper-sub-title">
        Після зміни, платником не зможе стати інша особа.
      </p>

      <form [formGroup]="form"
            class="become-payer-form">
        <div class="become-payer-form-phone">
          <mat-form-field class="form-input">
            <input [formControlName]="ControlNames.Phone"
                   [textMask]="PhoneMaskConfig"
                   type="tel"
                   phone
                   matInput
                   placeholder="Номер телефона відправника/отримувача"
                   autocomplete="off">
            <button *ngIf="phoneNumberIsLoading"
                    class="p-0 transform"
                    mat-button
                    matSuffix
                    mat-icon-button
                    [disabled]="true">
              <mat-spinner [diameter]="19.5" class="form-field-spinner"></mat-spinner>
            </button>
            <mat-error>{{ getError(phoneControl, phoneErrors) }}</mat-error>
          </mat-form-field>
          <div class="input-search-result" *ngIf="payerName">
            <p class="title">Контактна особа</p>
            <p class="name">{{ payerName }}</p>
          </div>
        </div>
        <div class="become-payer-form-edrpou">
          <mat-form-field class="form-input">
            <input [formControlName]="ControlNames.EDRPOU"
                   [mask]="'0000000000'"
                   [validation]="false"
                   matInput
                   placeholder="Код ЄДРПОУ/РНОКПП"
                   autocomplete="off">
            <button *ngIf="EDRPOUIsLoading"
                    class="p-0 transform"
                    mat-button
                    matSuffix
                    mat-icon-button
                    [disabled]="true">
              <mat-spinner [diameter]="19.5" class="form-field-spinner"></mat-spinner>
            </button>
            <mat-error>{{ getError(EDRPOUControl, EDRPOUErrors) }}</mat-error>
          </mat-form-field>
          <div class="input-search-result" *ngIf="organization?.Description">
            <p class="title">Організація</p>
            <p class="name">{{ organization.Description }}</p>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="become-payer-footer">
    <button mat-button
            (click)="submit()"
            [disabled]="loading$ | async"
            color="primary">
      Стати платником
    </button>
  </div>
</div>

